import { TOGGLE_SIDEBAR } from './sidebarConstants';

export const toggleSidebar = () => {
	return {
		type: TOGGLE_SIDEBAR
	};
};
